import React from 'react';
import { useOidc } from '@axa-fr/react-oidc';
import { ButtonV2, CoreButtonTypes } from '@metaforcelabs/metaforce-core';
import { signInReturnPath } from '../../utils/oidcUtilities';

/**
 * Shown by OidcProvider (sessionLostComponent) when a silent token refresh fails - the
 * user's session has genuinely expired. login(signInReturnPath()) sends them back to the
 * page they were on once they sign in again.
 */
const SessionLost = ({
  title = 'Session expired',
  message = 'Your session has expired. Please sign in again to continue.',
}) => {
  const { login } = useOidc();

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-background dark:bg-gray-800">
      <div className="max-w-md text-center p-8">
        <h1 className="text-2xl font-bold dark:text-white">{title}</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-300">{message}</p>
        <div className="mt-6">
          <ButtonV2 type={CoreButtonTypes.cta} label="Sign in again" onClick={() => login(signInReturnPath())} />
        </div>
      </div>
    </div>
  );
};

/**
 * Shown by OidcProvider (authenticatingErrorComponent) when the token exchange itself fails -
 * a used or stale sign-in link. No path/query survives this failure, so home is the
 * only safe destination: never built from this page's own URL, which rules out an off-site
 * redirect by construction. Calling login() unconditionally starts a fresh authorization round
 * trip rather than trusting a stale cached user object to mean sign-in already happened.
 */
export const AuthenticatingError = () => (
  <SessionLost
    title="Not authenticated"
    message="Your sign-in link has already been used. Sign in again to continue."
  />
);

export default SessionLost;
